"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateRangePicker = exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _materialUiPickers = require("material-ui-pickers");

var _dateFns = _interopRequireDefault(require("@date-io/date-fns"));

var _nb = _interopRequireDefault(require("date-fns/locale/nb"));

var _enGB = _interopRequireDefault(require("date-fns/locale/en-GB"));

var _dateFns2 = require("date-fns");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Popover = _interopRequireDefault(require("@material-ui/core/Popover"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));

var _Divider = _interopRequireDefault(require("@material-ui/core/Divider"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _styles = require("@material-ui/core/styles");

var _withWidth = _interopRequireDefault(require("@material-ui/core/withWidth"));

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _clsx = _interopRequireDefault(require("clsx"));

var _icons = require("../icons");

var _calendar = _interopRequireDefault(require("./calendar"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

_enGB.default.trans = {
  dateDisabledBefore: 'Date is invalid, it cannot be before today',
  dateDisabledAfter: 'Date is invalid, it cannot be after today',
  dateStringInvalid: 'The date is invalid'
};
_nb.default.trans = {
  dateDisabledBefore: 'Datoen er ugyldig, kan ikke være før dags dato',
  dateDisabledAfter: 'Datoen er ugyldig, kan ikke være etter dags dato',
  dateStringInvalid: 'Datoen er ugyldig'
};
var locales = {
  nb: _nb.default,
  en: _enGB.default,
  nn: _nb.default
};

var DialogComp = function DialogComp(_ref) {
  var children = _ref.children,
      open = _ref.open,
      handleClose = _ref.handleClose,
      classes = _ref.classes;
  return _react.default.createElement(_Dialog.default, {
    "aria-labelledby": "simple-modal-title",
    "aria-describedby": "simple-modal-description",
    open: open,
    onClose: handleClose,
    PaperProps: {
      className: classes.dialogASDFASDFASDFASDFASDFASD,
      elevation: 0
    }
  }, _react.default.createElement("div", null, children));
};

DialogComp.propTypes = {
  children: _propTypes.default.any.isRequired,
  open: _propTypes.default.bool.isRequired,
  handleClose: _propTypes.default.func.isRequired,
  classes: _propTypes.default.object.isRequired
};

var PopoverComp = function PopoverComp(_ref2) {
  var children = _ref2.children,
      handleClose = _ref2.handleClose,
      anchorEl = _ref2.anchorEl,
      open = _ref2.open;
  return _react.default.createElement(_Popover.default, {
    id: "calendar-popper",
    open: open,
    anchorEl: anchorEl,
    onClose: handleClose,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'center'
    }
  }, children);
};

PopoverComp.propTypes = {
  anchorEl: _propTypes.default.object,
  children: _propTypes.default.any.isRequired,
  open: _propTypes.default.bool.isRequired,
  handleClose: _propTypes.default.func.isRequired
};
PopoverComp.defaultProps = {
  anchorEl: null
};
var dialogComps = {
  xs: DialogComp,
  sm: DialogComp,
  md: PopoverComp,
  lg: PopoverComp
};

var DateRangePicker =
/*#__PURE__*/
function (_Component) {
  _inherits(DateRangePicker, _Component);

  function DateRangePicker(props) {
    var _this;

    _classCallCheck(this, DateRangePicker);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DateRangePicker).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClick", function (event) {
      _this.setState({
        anchorEl: event.currentTarget
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClose", function (reset) {
      _this.setState({
        anchorEl: null
      });

      var _this$props = _this.props,
          onChange = _this$props.onChange,
          onSearch = _this$props.onSearch;

      if (onSearch && reset) {
        var _this$state = _this.state,
            originalFrom = _this$state.originalFrom,
            originalTo = _this$state.originalTo;
        onChange('from', originalFrom);
        onChange('to', originalTo);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "search", function (e, dateFrom, dateTo) {
      var _this$props2 = _this.props,
          onSearch = _this$props2.onSearch,
          from = _this$props2.from,
          to = _this$props2.to;
      onSearch(e, dateFrom, dateTo);

      _this.setState({
        originalFrom: from,
        originalTo: to
      });
    });

    var _from = props.from,
        _to = props.to;
    _this.state = {
      anchorEl: null,
      originalFrom: _from,
      originalTo: _to
    };
    return _this;
  }

  _createClass(DateRangePicker, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          from = _this$props3.from,
          to = _this$props3.to,
          onChange = _this$props3.onChange,
          locale = _this$props3.locale,
          format = _this$props3.format,
          fromLabel = _this$props3.fromLabel,
          toLabel = _this$props3.toLabel,
          toProps = _this$props3.toProps,
          fromProps = _this$props3.fromProps,
          onSearch = _this$props3.onSearch,
          classes = _this$props3.classes,
          submitLabel = _this$props3.submitLabel,
          cancelLabel = _this$props3.cancelLabel,
          placeholder = _this$props3.placeholder,
          quickButs = _this$props3.quickButs,
          width = _this$props3.width,
          className = _this$props3.className,
          elevation = _this$props3.elevation;
      var anchorEl = this.state.anchorEl;
      var open = Boolean(anchorEl);
      var loc = locale in locales ? locales[locale] : _nb.default;
      var DialogUse = dialogComps[width] || PopoverComp;
      return _react.default.createElement("div", {
        className: (0, _clsx.default)(className)
      }, _react.default.createElement(_Paper.default, {
        className: classes.searchPaper,
        elevation: elevation
      }, _react.default.createElement(_IconButton.default, {
        "aria-owns": open ? 'calendar-popper' : undefined,
        "aria-haspopup": "true",
        onClick: this.handleClick,
        className: classes.iconButton,
        "aria-label": "open date range popup"
      }, _react.default.createElement(_icons.DateRangeIcon, null)), _react.default.createElement(_Typography.default, {
        id: "outlined-name",
        className: classes.rangeDisplay,
        onChange: this.parseTextFieldData,
        onClick: this.handleClick
      }, from && to && [_react.default.createElement("span", {
        key: "from"
      }, "".concat((0, _dateFns2.format)(from, format, {
        locale: loc
      }), " - ")), _react.default.createElement("span", {
        className: classes.dateSpan,
        key: "to"
      }, (0, _dateFns2.format)(to, format, {
        locale: loc
      }))] || placeholder), onSearch && [_react.default.createElement(_Divider.default, {
        key: "div",
        className: classes.horDivider
      }), _react.default.createElement(_IconButton.default, {
        className: classes.iconButton,
        key: "search",
        onClick: this.search
      }, _react.default.createElement(_icons.SearchIcon, null))]), _react.default.createElement(DialogUse, {
        open: open,
        anchorEl: anchorEl,
        handleClose: this.handleClose,
        classes: classes
      }, _react.default.createElement(_materialUiPickers.MuiPickersUtilsProvider, {
        utils: _dateFns.default,
        locale: loc
      }, _react.default.createElement(_Paper.default, {
        className: classes.calMaster
      }, _react.default.createElement("div", {
        className: classes.calendars
      }, _react.default.createElement(_calendar.default, {
        label: fromLabel,
        value: from,
        fieldName: "from",
        calendarProps: fromProps,
        onChange: onChange,
        locale: loc,
        onEnterKeyPress: function onEnterKeyPress(e) {
          _this2.handleClose();

          if (onSearch) {
            _this2.search(e);
          }
        }
      }), _react.default.createElement(_calendar.default, {
        label: toLabel,
        value: to,
        fieldName: "to",
        calendarProps: toProps,
        onChange: onChange,
        locale: loc,
        onEnterKeyPress: function onEnterKeyPress(e) {
          _this2.handleClose();

          if (onSearch) {
            _this2.search(e);
          }
        }
      })), _react.default.createElement("div", {
        className: classes.calendarContainer
      }, _react.default.createElement(_Paper.default, {
        elevation: 0,
        className: classes.buttonList
      }, quickButs && quickButs.map(function (_ref3) {
        var dateFrom = _ref3.dateFrom,
            dateTo = _ref3.dateTo,
            label = _ref3.label;
        return _react.default.createElement(CalQuickBut, {
          key: label,
          dateFrom: dateFrom,
          dateTo: dateTo,
          onChange: onChange,
          search: onSearch && _this2.search,
          handleClose: _this2.handleClose
        }, label);
      }), quickButs && _react.default.createElement(_Divider.default, {
        key: "div",
        className: classes.verDivider
      }), _react.default.createElement(CalQuickBut, {
        key: "doneBut",
        onClick: function onClick(e) {
          _this2.handleClose();

          if (onSearch) {
            _this2.search(e);
          }
        }
      }, submitLabel), onSearch && _react.default.createElement(CalQuickBut, {
        key: "cancelBut",
        onClick: function onClick() {
          _this2.handleClose(true);
        }
      }, cancelLabel)))))));
    }
  }]);

  return DateRangePicker;
}(_react.Component);

exports.DateRangePicker = DateRangePicker;
DateRangePicker.propTypes = {
  /** Label on 'done'-button to close the popover. Calls onSearch if onSearch is specified */
  submitLabel: _propTypes.default.any,

  /** Label on 'cancel'-button to close the popover without calling onSearch when onSearch is
   * specified */
  cancelLabel: _propTypes.default.any,

  /** Label over 'from'-calendar */
  fromLabel: _propTypes.default.any,

  /** Label over 'to'-calendar */
  toLabel: _propTypes.default.any,

  /** DateFns format på dato-visning */
  format: _propTypes.default.string,

  /** Lokalisering, støttet nå er: en (Britisk), nb (Norsk), nn (Samme som nb) */
  locale: _propTypes.default.string,

  /** Date 'fra'-objekt */
  from: _propTypes.default.instanceOf(Date).isRequired,

  /** Date 'til'-objekt */
  to: _propTypes.default.instanceOf(Date).isRequired,

  /** onChange blir kalt hver gang en av datoene endrer seg med to argumenter:
   * ('from'|'to', Date) */
  onChange: _propTypes.default.func.isRequired,

  /** Props som sendes direkte inn i 'to'date-picker-en */
  toProps: _propTypes.default.object,

  /** Props som sendes direkte inn i 'from'date-picker-en */
  fromProps: _propTypes.default.object,

  /** Funksjon som blir kalt når søkeknappen trykkes eller submit-knappen trykkes i popover-en.
   * Søkeknappen vises om denne er definert */
  onSearch: _propTypes.default.func,

  /** Tekst som står om fra og til ikke er spesifisert */
  placeholder: _propTypes.default.string,

  /** Liste med definisjoner for predefinerte intervaller.
   * Feks: [{dateFrom: subDays(new Date(), 15), dateTo: new Date(), label: 'Siste 15 dager'}] */
  quickButs: _propTypes.default.array,

  /** className blir satt på SearchPaper, den boksen som viser valgte datoer */
  className: _propTypes.default.any,

  /** elevation prop passed to MuiPaper */
  elevation: _propTypes.default.number
};
DateRangePicker.defaultProps = {
  submitLabel: 'Done',
  cancelLabel: 'Cancel',
  fromLabel: 'From',
  toLabel: 'To',
  toProps: {},
  fromProps: {},
  locale: 'nb',
  format: 'PPP',
  onSearch: undefined,
  placeholder: '',
  quickButs: undefined,
  className: undefined,
  elevation: 1
};

var styles = function styles(theme) {
  var _calMaster;

  return {
    dateSpan: {
      whiteSpace: 'nowrap'
    },
    dialogASDFASDFASDFASDFASDFASD: {
      margin: '0px'
    },
    calMaster: (_calMaster = {
      display: 'flex',
      flexDirection: 'row'
    }, _defineProperty(_calMaster, theme.breakpoints.down('sm'), {
      flexDirection: 'column-reverse'
    }), _defineProperty(_calMaster, "margin", '0px'), _calMaster),
    calendarContainer: {
      margin: '1rem',
      display: 'flex',
      justifyContent: 'center'
    },
    calendars: _defineProperty({}, theme.breakpoints.up('md'), {
      display: 'flex',
      flexDirection: 'row'
    }),
    horDivider: {
      width: 1,
      height: 28,
      margin: 4
    },
    verDivider: {
      width: '100%',
      height: 1,
      margin: 4
    },
    searchPaper: {
      padding: '2px 4px',
      display: 'flex',
      alignItems: 'center'
    },
    rangeDisplay: {
      marginLeft: 8,
      flex: 1,
      cursor: 'pointer'
    },
    iconButton: {
      padding: 10
    },
    buttonList: {
      minWidth: '13rem',
      maxWidth: '18rem'
    },
    calButton: {
      marginTop: '0.5rem',
      marginBottom: '0.5rem',
      width: '100%'
    }
  };
};

var CalQuickBut = (0, _styles.withStyles)(styles)(function (_ref4) {
  var children = _ref4.children,
      classes = _ref4.classes,
      dateFrom = _ref4.dateFrom,
      dateTo = _ref4.dateTo,
      onChange = _ref4.onChange,
      onClick = _ref4.onClick,
      search = _ref4.search,
      handleClose = _ref4.handleClose;
  return _react.default.createElement(_Button.default, {
    color: "primary",
    variant: "contained",
    className: classes.calButton,
    onClick: onClick || function (e) {
      onChange('from', dateFrom || new Date());
      onChange('to', dateTo || new Date()); // use today if no dateTo specified

      if (search) {
        search(e, dateFrom || new Date(), dateTo || new Date());
      }

      if (handleClose) {
        handleClose();
      }
    }
  }, children);
});

var _default = (0, _withWidth.default)()((0, _styles.withStyles)(styles)(DateRangePicker));

exports.default = _default;